/**
 * @classdesc Eine Klasse, die eine Funktion "onComplete" ausführt, wenn ihr interner Counter 0 (oder kleiner) erreicht.
 * @class
 * @param {Object}      context           context, in dem onComplete ausgeführt werden soll
 * @param {function}    callbackOnAdd     Funktion, die aufgerufen werden soll, wenn ein Task geadded wird (bspw. Ladebalken einblenden)
 * @param {function}    onComplete        Funktion, die bei erreichen von pending === 0 ausgeführt werden soll
 * @param {string}      [nameOfParent="nicht angegeben"]
 *
 */
import {EventVerteiler} from "../global/eventVerteiler";
import DEBUG from "./DEBUG";


export class TaskCounter {
    private readonly context;
    private pending : number;
    private readonly pendingByTask;
    private onComplete :()=>void;
    private readonly onAdd:()=>void;
    private readonly nameOfParent : string;

    constructor(context, callbackOnAdd, onComplete, nameOfParent = "nicht angegeben") {

        this.context = context;
        this.pending = 0;
        this.pendingByTask = [];
        this.onComplete = onComplete;
        this.onAdd = callbackOnAdd;
        this.nameOfParent = nameOfParent || "nicht angegeben";
    }

    taskFinished(taskName?) {
        if (typeof (taskName) === "undefined") {
            taskName = "";
        }
        this.pending -= 1;
        if (taskName !== "" && typeof(this.pendingByTask[taskName]) !== "undefined") {
            this.pendingByTask[taskName]--;
            if (this.pending < this.pendingByTask[taskName]) {
                if (DEBUG) {
                    console.warn("mismatch between task " + taskName + ": " + this.pendingByTask[taskName] + " and global taskCounter: " + this.pending);
                }
                this.pendingByTask[taskName] = this.pending;
            }
            if (this.pendingByTask[taskName] === 0) {
                EventVerteiler.broadcast("taskCounterTaskFinishedEvent", {
                    nameOfParent: this.nameOfParent,
                    taskName: taskName
                });
                delete this.pendingByTask[taskName];
            }
        }

        if (this.pending < 0) {
            if (DEBUG) {
                console.log("Taskcounter: pendingTask ist " + this.pending + "; ich gehöre: " + this.nameOfParent);
            }
            this.pending = 0;
        }

        if (this.pending <= 0) {
            this.onComplete.call(this.context);
        }
    }
    addTasks(numberOfTasks, taskName?) {
        this.pending += numberOfTasks;

        if (typeof(this.onAdd) === "function") {
            this.onAdd.call(this.context);
        }
        if (typeof(taskName) !== "undefined") {
            if (typeof (this.pendingByTask[taskName]) === "undefined") {
                this.pendingByTask[taskName] = numberOfTasks;
            } else {
                this.pendingByTask[taskName] += numberOfTasks;
            }
        }
    }
}